var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { id: "email_signup", novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("h4", { staticClass: "text-xl mb-3" }, [
        _vm._v("Stay in touch with us"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-with-button" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email",
            },
          ],
          staticClass: "input-with-button__el",
          attrs: {
            type: "email",
            name: "email",
            placeholder: "Email",
            disabled: _vm.success || _vm.loading,
          },
          domProps: { value: _vm.email },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
              _vm.clearMessages,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "input-with-button__button",
            attrs: { type: "submit", disabled: _vm.success || _vm.loading },
          },
          [
            _c("SubmitArrow"),
            _vm._v(" "),
            _c("span", { staticClass: "sr-only" }, [_vm._v("Submit")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.success && _vm.successMessage.length
          ? _c("div", { staticClass: "success_message success" }, [
              _vm._v(_vm._s(_vm.successMessage)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.error && _vm.errorMessage.length
          ? _c("div", { staticClass: "error_message error" }, [
              _vm._v("Please enter a valid email"),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }